import { Close } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import FallbackComponent from "../../../../../components/fallbackComponent/FallbackComponent";
import { InboundDeliveryDetailsTimeFragment } from "../../../../../models/autogenerated-deliveryService-gql/graphql";
import DetailsTimeline from "./detailsTimeline/DetailsTimeline";

interface DetailsTimesTabProps {
  times: InboundDeliveryDetailsTimeFragment[];
}

const DetailsTimesTab = (props: DetailsTimesTabProps) => {
  const { t } = useTranslation();
  const { times } = props;

  if (times.length === 0)
    return (
      <FallbackComponent
        middleIcon={<Close size={32} />}
        text={t("noTimesExist")}
      />
    );

  return <DetailsTimeline times={times} />;
};

export default DetailsTimesTab;
